import React from 'react';
import { Route } from 'react-router-dom';
import TechnicianLayout from '../views/Technician/TechnicianLayout';
import TechnicianDashboard from '../views/Technician/TechnicianDashboard';

const technicianRoutes = (
  <Route path="/technician" element={<TechnicianLayout />}>
    <Route index element={<TechnicianDashboard />} />
  </Route>
);

export default technicianRoutes;
